// extracted by mini-css-extract-plugin
export default {"heading":"Cx-z","corrected":"Dx-z","redirectVerbiageContainer":"Ex-z","redirectVerbiageText":"Fx-z"};